<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>加盟商电子合同签署</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
      <!-- 检索 -->
      <el-form :model="listQuery" :inline="true">
        <el-form-item label="合同类型">
          <el-select
            v-model="listQuery.type"
            filterabler="请选择合同类型"
            collapse-tags
            clearable
          >
            <el-option
              v-for="(value, key) in contractTypes"
              :key="key"
              :label="value"
              :value="key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input
            v-model="listQuery.name"
            placeholder="请输入签署人姓名"
            filterable
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input
            v-model="listQuery.tel"
            placeholder="请输入签署人电话"
            filterable
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="签署状态">
          <el-select
            v-model="listQuery.state"
            placeholder="请选择签署状态"
            filterable
            clearable
          >
            <el-option value="1" label="未签署"></el-option>
            <el-option value="2" label="已签署"></el-option>
            <el-option value="3" label="已取消"></el-option>
          </el-select>
        </el-form-item>

        <el-button type="primary" @click="clickSearch">查询</el-button>
      </el-form>
      <!-- style="pointer-events: none;opacity: 0.5;"-->
      <div>
        以下合同已停用不可签署
      <el-row class="btn-margin">
        <el-button class type="success" plan @click="jmsfuwuhetong()"
          >加盟商服务合同
        </el-button>
        <el-button class type="success" plan @click="zhixun('苏州')"
          >市场咨询服务合同（苏州）</el-button
        >
        <el-button class type="success" plan @click="zhixun('杭州')"
          >市场咨询服务合同（杭州）</el-button
        >
        <el-button class type="success" plan @click="zhixun('宅景')"
          >市场咨询服务合同（宅景）</el-button
        >
        <el-button class type="success" plan @click="texujingying()"
          >特许经营合同</el-button
        >
        <el-button class type="success" plan @click="xinxihuizhi()"
          >信息披露回执</el-button
        >
        <el-button class type="danger" plan @click="createqb()"
          >开通eqb机构章</el-button
        >
        <el-button class type="success" plan @click="jmsYHContract('杭州')"
          >加盟商优惠协议</el-button
        >
      </el-row>
      <el-row class="btn-margin">
        <el-button class type="success" plan @click="jmsYHContract('宅景')"
          >加盟商优惠协议（宅景）</el-button
        >
        <el-button class type="success" plan @click="snfwxyht()"
          >收纳服务协议合同</el-button
        >
        <el-button class type="success" plan @click="jmsSFXYContract()"
          >加盟商三方协议</el-button
        >

        <el-button class type="success" plan @click="jmsYYHZXYContract()"
          >加盟商运营合作协议/补充协议</el-button
        >
        <el-button class type="success" plan @click="jmsZHZRSQHContract()"
          >商家账户转让申请承诺函</el-button
        >
      </el-row>
      <el-row class="btn-margin">
        <el-button class type="info" plan @click="txjyqybc()"
          >特许经营合同补充协议-区域补充</el-button
        >
        <el-button class type="info" plan @click="sczxbcxy('苏州')"
          >市场咨询补充协议（苏州）</el-button
        >
        <el-button class type="info" plan @click="txjybcxyztbg()"
          >特许经营补充协议-主体变更</el-button
        >
        <el-button class type="info" plan @click="sczxbcxy('杭州')"
          >市场咨询补充协议（杭州）</el-button
        >
        <el-button class type="info" plan @click="sczxbcxy('宅景')"
          >市场咨询补充协议（宅景）</el-button
        >
      </el-row>
      <el-row class="btn-margin">
        <el-button class type="info" plan @click="txjyqybcNew('上海')"
          >特许经营合同补充协议-区域补充（区域自定义-上海）</el-button
        >
        <el-button class type="info" plan @click="txjyqybcNew('杭州')"
          >特许经营合同补充协议-区域补充（区域自定义-杭州）</el-button
        >
        <el-button class type="info" plan @click="txjyqybcNew('宅景')"
          >特许经营合同补充协议-区域补充（区域自定义-宅景）</el-button
        >
      </el-row>
      <el-row>
        <el-button class type="danger" plan @click="jmsServiceRelieve()"
          >服务合同解除协议</el-button
        >
        <el-button class type="danger" plan @click="jmsSCZXRelieve('苏州')"
          >市场咨询服务合同解除协议(苏州)</el-button
        >
        <el-button class type="danger" plan @click="jmsSCZXRelieve('杭州')"
          >市场咨询服务合同解除协议(杭州)</el-button
        >
        <el-button class type="danger" plan @click="jmsSCZXRelieve('宅景')"
          >市场咨询服务合同解除协议(宅景)</el-button
        >
        <el-button class type="danger" plan @click="jmsTXJYRelieveContract()"
          >特许经营合同解除协议</el-button
        >
      </el-row>
      </div>
      <!-- 列表数据 -->
      <el-table
        :data="processListData"
        border
        style="width: 100%"
        class="table"
      >
        <el-table-column prop="processId" label="流程ID"></el-table-column>
        <el-table-column
          prop="contractNo"
          label="合同编号"
          width="150px"
        ></el-table-column>
        <el-table-column prop="fraName" label="加盟商"></el-table-column>
        <el-table-column
          prop="signName"
          label="姓名"
          width="90px"
        ></el-table-column>
        <el-table-column
          prop="tel"
          label="电话"
          width="100px"
        ></el-table-column>
        <el-table-column prop="address" label="地址"></el-table-column>

        <el-table-column prop="type" label="合同类型" width="320px">
          <template slot-scope="scope">
            <el-tag>{{ contractTypes[scope.row.type] }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="state" label="签署状态" width="100px">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.state == 1">未签署</el-tag>
            <el-tag v-if="scope.row.state == 2" type="success">已签署</el-tag>
            <!-- <el-tag v-if="scope.row.state == 3">已取消</el-tag> -->
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="发起时间"
          :formatter="dateFormatA"
          width="150px"
        ></el-table-column>

        <el-table-column
          prop="creatorName"
          label="操作"
          fixed="right"
          width="180px"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="checkSignAdressBtn(scope.row)"
              >查看签约地址</el-button
            >
            <el-button
              type="text"
              @click="previewBtn(scope.$index, scope.row)"
              v-loading.fullscreen.lock="fullscreenLoading"
              >预览
            </el-button>
            <!-- <el-button type="text" @click="cancelSign(scope.row)" class="textWarning"
                            v-if="scope.row.state == 1 && (scope.row.type == 105 || scope.row.type == 110)">取消
                        </el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页  -->
      <pagination
        :total="total"
        :page.sync="currentPage"
        :limit.sync="pageSize"
        @pagination="querySearch"
      />
    </el-card>

    <!--加盟商服务合同-->
    <jmsServiceContract @querySearch="querySearch" ref="jmsServiceContract" />

    <!--市场咨询服务合同-->
    <jmsSCJYContract @querySearch="querySearch" ref="jmsSCJYContract" />

    <!--特许经营合同-->
    <jmsTXJYContract @querySearch="querySearch" ref="jmsTXJYContract" />

    <!--信息回执合同-->
    <jmsXXHZContract @querySearch="querySearch" ref="jmsXXHZContract" />

    <!--信息回执合同-->
    <creatEQB @querySearch="querySearch" ref="creatEQB" />

    <!--特许经营合同补充协议-区域补充-->
    <jmsQYBC_TXJYContract
      @querySearch="querySearch"
      ref="jmsQYBC_TXJYContract"
    />

    <!--市场咨询补充协议-->
    <jmsSCZXBCXY @querySearch="querySearch" ref="jmsSCZXBCXY" />

    <!--特许经营补充协议-主体变更-->
    <jmsTXJYBCXYZTBG @querySearch="querySearch" ref="jmsTXJYBCXYZTBG" />

    <jmsSNFWSContract @querySearch="querySearch" ref="jmsSNFWSContract" />
    <!--特许经营合同补充协议-区域编辑-->
    <jmsTXJY_BCContract @querySearch="querySearch" ref="jmsTXJY_BCContract" />
    <!--          服务合同解除-->
    <jmsServiceRelieveContract
      @querySearch="querySearch"
      ref="jmsServiceRelieveContract"
    />
    <!--          市场咨询合同解除协议-->
    <jmsSCZXRelieveContract
      @querySearch="querySearch"
      ref="jmsSCZXRelieveContract"
    />
    <!--      特许经营合同解除协议-->
    <jmsTXJYRelieveContract
      @querySearch="querySearch"
      ref="jmsTXJYRelieveContract"
    />

    <!--      加盟商优惠合同-->
    <jmsYHContract @querySearch="querySearch" ref="jmsYHContract" />

    <jmsSFXYContract @querySearch="querySearch" ref="jmsSFXYContract" />

    <!-- 加盟商运营合作协议、运营合作协议补充协议 -->
    <jmsYYHZXYContract @querySearch="querySearch" ref="jmsYYHZXYContract" />

    <!-- 商家账户转让申请承诺函 -->
    <jmsZHZRContract @querySearch="querySearch" ref="jmsZHZRContract" />

    <!-- 签约地址 -->
    <signAdressDia ref="signAdressDiaRef" />
  </div>
</template>
<script>
import Pagination from "@/components/common/Pagination";
import globalData from "@/components/common/globaldata/global.data.vue";
// import contractprocedure from '@/script/api/contractprocedure';
import contractApi from "@/script/api/contractapi";

import jmsSCJYContract from "@/components/jmsContract/compent/jmsSCJYContract";
import jmsServiceContract from "@/components/jmsContract/compent/jmsServiceContract";
import jmsTXJYContract from "@/components/jmsContract/compent/jmsTXJYContract";
import jmsXXHZContract from "@/components/jmsContract/compent/jmsXXHZContract";
import creatEQB from "@/components/jmsContract/compent/creatEQB";
import jmsQYBC_TXJYContract from "@/components/jmsContract/compent/jmsQYBC_TXJYContract";
import jmsTXJY_BCContract from "@/components/jmsContract/compent/jmsTXJY_BCContract";
import jmsSCZXBCXY from "@/components/jmsContract/compent/jmsSCZXBCXY";
import jmsTXJYBCXYZTBG from "@/components/jmsContract/compent/jmsTXJYBCXYZTBG";
import jmsSNFWSContract from "@/components/jmsContract/compent/jmsSNFWSContract";
import jmsServiceRelieveContract from "@/components/jmsContract/compent/jmsServiceRelieveContract";
import jmsSCZXRelieveContract from "@/components/jmsContract/compent/jmsSCZXRelieveContract";
import jmsTXJYRelieveContract from "@/components/jmsContract/compent/jmsTXJYRelieveContract";
import jmsYHContract from "@/components/jmsContract/compent/jmsYHContract";
import jmsSFXYContract from "@/components/jmsContract/compent/jmsSFXYContract";
import jmsYYHZXYContract from "@/components/jmsContract/compent/jmsYYHZXYContract";
import jmsZHZRContract from "@/components/jmsContract/compent/jmsZHZRContract";

import signAdressDia from "@/components/workercrm/contract/compent/signAdressDia";

export default {
  components: {
    Pagination,
    jmsServiceContract,
    jmsSCJYContract,
    jmsTXJYContract,
    jmsXXHZContract,
    creatEQB,
    signAdressDia,
    jmsQYBC_TXJYContract,
    jmsSCZXBCXY,
    jmsTXJYBCXYZTBG,
    jmsSNFWSContract,
    jmsTXJY_BCContract,
    jmsServiceRelieveContract,
    jmsSCZXRelieveContract,
    jmsTXJYRelieveContract,
    jmsYHContract,
    jmsSFXYContract,
    jmsYYHZXYContract,
    jmsZHZRContract
  },
  data() {
    return {
      contractTypes: {
        201: "加盟商服务合同",
        202: "市场咨询服务合同",
        203: "特许经营合同",
        204: "信息披露回执",
        205: "特许经营合同补充协议-区域补充",
        206: "市场咨询补充协议",
        207: "特许经营补充协议-主体变更",
        208: "收纳服务商合同",
        209: "市场咨询服务合同（杭州）",
        210: "市场咨询补充协议（杭州）",
        211: "特许经营合同补充协议-区域补充(区域自定义-上海)",
        212: "服务合同解除协议",
        213: "市场咨询服务合同解除协议（苏州）",
        214: "市场咨询服务合同解除协议（杭州）",
        215: "特许经营合同解除协议",
        216: "特许经营合同补充协议-区域补充(区域自定义-杭州)",
        217: "加盟商优惠合同",
        218: "市场咨询服务合同（宅景）",
        219: "市场咨询服务合同解除协议（宅景）",
        220: "市场咨询补充协议（宅景）",
        221: "加盟商三方协议",
        222: "特许经营合同补充协议-区域补充(区域自定义-宅景)",
        223: "加盟商优惠协议-宅景",
        224: "运营合作协议",
        225: "运营合作协议补充协议",
        226: "生服平台商家账户转让申请承诺函"
      },
      showSign: false,
      PDFVisible: false,
      contractUrl: "",

      fullscreenLoading: false,
      processListData: [],
      total: 0,
      pageSize: 10,
      currentPage: 1, //当前页
      listQuery: {
        name: "",
        tel: "",
        state: null,
        type: null
      },
      singList: []
    };
  },
  created() {
    this.querySearch();
  },
  methods: {
    snfwxyht() {
      this.$refs.jmsSNFWSContract.showDetail(null);
    },
    txjybcxyztbg() {
      this.$refs.jmsTXJYBCXYZTBG.showDetail(null);
    },
    sczxbcxy(city) {
      this.$refs.jmsSCZXBCXY.showDetail(city);
    },
    txjyqybc() {
      this.$refs.jmsQYBC_TXJYContract.showDetail(null);
    },
    txjyqybcNew(city) {
      this.$refs.jmsTXJY_BCContract.showDetail(city);
    },
    jmsfuwuhetong() {
      this.$refs.jmsServiceContract.showDetail(null);
    },
    zhixun(city) {
      this.$refs.jmsSCJYContract.showDetail(city);
    },
    texujingying() {
      this.$refs.jmsTXJYContract.showDetail(null);
    },
    xinxihuizhi() {
      this.$refs.jmsXXHZContract.showDetail(null);
    },
    jmsServiceRelieve() {
      this.$refs.jmsServiceRelieveContract.showDetail(null);
    },
    jmsSCZXRelieve(city) {
      this.$refs.jmsSCZXRelieveContract.showDetail(city);
    },
    jmsTXJYRelieveContract() {
      this.$refs.jmsTXJYRelieveContract.showDetail();
    },
    jmsYHContract(city) {
      this.$refs.jmsYHContract.showDetail(city);
    },
    jmsSFXYContract() {
      this.$refs.jmsSFXYContract.showDetail();
    },
    jmsYYHZXYContract() {
      this.$refs.jmsYYHZXYContract.showDetail();
    },
    jmsZHZRSQHContract() {
      this.$refs.jmsZHZRContract.showDetail();
    },
    createqb() {
      this.$refs.creatEQB.showDetail(null);
    },
    checkSignAdressBtn(row) {
      //查看签署地址
      this.$refs.signAdressDiaRef.signAdressDiaRow(row);
    },
    clickSearch() {
      this.currentPage = 1;
      this.querySearch();
    },
    // exportExcel() {
    //     let reqData = {
    //         name: this.listQuery.name,
    //         tel: this.listQuery.tel,
    //         state: this.listQuery.state,
    //         type: this.listQuery.type,
    //         isExport: true,
    //         userId: globalData.userInfo.id,
    //     };
    //     contract.$download(reqData, "合同数据明细");
    // },
    //查询
    querySearch() {
      let reqData = {
        name: this.listQuery.name,
        tel: this.listQuery.tel,
        state: this.listQuery.state,
        type: this.listQuery.type,
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      contractApi.$ajaxJmsContractGetPageList(reqData).then(res => {
        if (res.data.errno == 0) {
          this.total = res.data.data.total;
          this.processListData = res.data.data.list;
        }
      });
    },
    //预览
    previewBtn(index, row) {
      this.fullscreenLoading = true;
      contractApi
        .$ajaxselectContractFile({
          procedureId: row.processId
        })
        .then(res => {
          if (res.data.errno == 0) {
            window.open(
              "/static/pdf/web/viewer.html?file=" +
                encodeURIComponent(res.data.data.downloadUrl)
            );
            this.fullscreenLoading = false;
          }
        });
    },
    //   取消
    cancelSign(row) {
      this.$confirm("是否确定取消?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          contractApi
            .$ajaxCancelSign({
              processId: row.processId
            })
            .then(res => {
              if (res.data.errno == 0) {
                this.$message.success("取消成功");
                this.querySearch();
              }
            });
        })
        .catch(() => {});
    }
  }
};
</script>
<style scoped>
.person-dialog .el-select {
  width: 300px;
}

.person-dialog .el-dialog__body {
  height: 160px;
}
</style>
